import { Bubble, Dropdown } from 'tea-component';
import React from 'react';
import './index.scss';
import { DimensionSelect } from './Options/dimension_select';
import type { IColumnInfo, IDimensionRange } from '@dbl/core/dataSource';
import { FieldSelect } from '../widgets/FieldSelect';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useDblIntl } from "@/pages/datalab/utils/utils";

export function DimensionItem(props: {
  column: IColumnInfo;
  index: number;
  optionDimensions: any[];
  handle: any;
  selectedItems: string[];
  hasDimensionSelect?: boolean;
  onSelectItem: (newItemName: string) => void;
  fieldSelectClassName?: string;
  handleContent?: (option: any) => React.ReactNode;
}) {
  const { dblFormatMessage: explorationFormatMessage, commonFormatMessage, isEn } = useDblIntl("exploration");
  const { column, index, optionDimensions, handle, selectedItems, hasDimensionSelect = true, onSelectItem, fieldSelectClassName = '', handleContent } = props;
  const { removeItem, notifyItems } = handle;

  const notify = (dimensionType: string, dimensionRanges?: IDimensionRange[]) => {
    column.dimension_type = dimensionType;
    column.dimension_rangs = dimensionRanges;
    notifyItems();
  };

  return (
    <div className="model-port">
      <div className="total-tab">
        <div className="label-num">{index}</div> <SvgIcon type="drag-icon" className="label-icon" />
        <span className="total-tab-text">{explorationFormatMessage("by")}</span>
        <Dropdown
          className="dtl-tab-field-select"
          appearance="button"
          button={isEn ? column.column_name : column.column_display}
          clickClose={false}
        >
          <FieldSelect
            className={fieldSelectClassName ?? ''}
            fieldValue={column.column_name}
            fieldSelected={selectedItems}
            fieldOptions={optionDimensions}
            onSelectItem={onSelectItem}
            handleContent={handleContent}
          />
        </Dropdown>
        {
          hasDimensionSelect && <>
            <span className="total-tab-text">{explorationFormatMessage("of")}</span>
            <DimensionSelect column={column} notify={notify} />
          </>
        }
        <span className="total-tab-text">{explorationFormatMessage("calculate_by_dimension")}</span>
        <Bubble
          dark={true}
          arrowPointAtCenter
          placement="top"
          content={
            <div>
              <p>{commonFormatMessage("delete")}</p>
            </div>
          }
        >
          <i
            className="label-close"
            onClick={() => {
              removeItem(column);
            }}
          >
            <SvgIcon type="clonse" />
          </i>
        </Bubble>
      </div>
    </div>
  );
}
